export default __webpack_public_path__ + "static/media/ArchiveProspectBlue.b855796f.svg";